export const CHAT_ICON_COLOR = '#F2B705';
